import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "How does the AI resume builder work?",
    a: "You add a few notes about your experience and our AI (GPT-5.4) turns them into polished, quantified bullet points and a strong professional summary. You pick a template, see a live A4 preview, and export a recruiter-ready PDF in one click. It's free to start.",
  },
  {
    q: "What does 'Talk to an Expert' cost and how does it work?",
    a: "Browse verified professionals across industries — from banking & finance to specialised technical fields — view their profile and availability, and book a one-on-one consultation slot. You submit a booking request and our team confirms your call. Pricing is shared on each expert's profile.",
  },
  {
    q: "What is the 'Improve Resume' feature?",
    a: "Upload or paste your existing resume and our AI rewrites it into a sharper, ATS-friendly version. You get a free watermarked preview so you can see the quality before you decide. To download the clean, watermark-free version, you complete a quick payment.",
  },
  {
    q: "Is my data and resume kept private?",
    a: "Yes. Your resume content and personal details are used only to generate and improve your documents. Expert phone numbers and private contact details are never exposed publicly, and hiring requests are kept private to our admin team.",
  },
  {
    q: "Do you guarantee a job placement?",
    a: "No. ResumePro24 provides resume-writing tools, expert consultations, and job-finding support to strengthen your candidacy. We do not guarantee interviews, offers, or job placements of any kind — outcomes depend on many factors outside our control.",
  },
  {
    q: "How do I apply for jobs listed on the site?",
    a: "Visit the Jobs page to browse open positions, then click 'Apply now' to submit your details and resume for a specific role. Our hiring team reviews applications and matches candidates with companies that are actively hiring.",
  },
  {
    q: "Which payment methods do you accept?",
    a: "Payment options are shown at checkout when you download an improved resume or confirm certain services. If you have any billing questions, reach out to our support team.",
  },
];

export const FAQ = () => {
  return (
    <section className="bg-secondary/40 border-y border-border" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 py-24">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-xs font-medium mb-4">
            <HelpCircle className="h-3.5 w-3.5 text-primary" /> Frequently asked questions
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight">
            Everything you need to know
          </h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-base hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed text-sm">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
